// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"a7f1ce28","628":"c953270f"}[chunkId] + ".chunk.js";
};